// Viewport Sizing
// xs, extra-small: 0px
// sm, small: 600px
// md, medium: 900px
// lg, large: 1280px
// xl, extra-large: 1920px
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DeleteIcon from '@mui/icons-material/Delete';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddIcon from '@mui/icons-material/Add';

export const AccountDetailsHeader = styled.h3.attrs({
  id: 'accountDetailsHeader',
  'aria-label': 'Account Details Header',
})`
  font-family: 'Helvetica Neue', Lato, proxima-nova, Arial, Helvetica, sans-serif, sans-serif;
  font-size: 18px;
  margin-left: 30px;
`;

export const PayoffCurrentDueAndDueDateContainer = styled.div.attrs({
  id: 'payoffCurrentDueAndDueDateContainer',
  'aria-label': 'Payoff and Current Due Date Container',
})`
  display: grid;
  margin-left: 30px;
  margin-bottom: 26px;
  @media (max-width: 900px) {
    grid-template-areas:
      ' payoff '
      ' currentdue'
      ' duedate';
    row-gap: 16px;
  }
  @media (min-width: 900px) {
    margin-left: 30px;
    grid-template-areas: ' payoff currentdue duedate ';
  }
`;

export const PayoffContainer = styled.div.attrs({
  id: 'payoffAmountContainer',
  'aria-label': 'Payoff Amount Container',
})`
  display: grid;

  grid-template-areas:
    ' header '
    ' data';
  @media (max-width: 900px) {
  }
  @media (min-width: 900px) {
    margin-left: 30px;
    row-gap: 16px;
  }
`;
export const ChangePayScheduleContainer = styled.div.attrs({
  id: 'changePayContainer',
  'aria-label': 'Change Pay Schedule Container',
})`
  margin: 20px 0;
  font-weight: 600;
`;
export const ChangePayMethodContainer = styled.div.attrs({
  id: 'changePayContainer',
  'aria-label': 'Change Pay Method Container',
})`
  margin-top: 20px;
  font-weight: 600;
`;
export const PayPlanPayInformation = styled.div.attrs({
  id: 'payPlanInformation',
  'aria-label': 'Pay Plan Information',
})`
  margin: 20px 0 0 0;
  display: inline-block;
`;
export const PaymentInfo = styled.span.attrs({
  id: 'PayInfo',
  'aria-label': 'Pay Information',
})`
  margin: 20px 0;
  font-weight: 600;
`;
export const CurrentDueContainer = styled.div.attrs({
  id: 'currentDueContainer',
  'aria-label': 'Current Due Container',
})`
  display: grid;

  grid-template-areas:
    ' header '
    ' data';
  @media (max-width: 900px) {
  }
  @media (min-width: 900px) {
    margin-left: 30px;
    row-gap: 16px;
  }
`;
export const DueDateContainer = styled.div.attrs({
  id: 'dueDateContainer',
  'aria-label': 'Due Date Container',
})`
  display: grid;

  grid-template-areas:
    ' header '
    ' data';
  @media (max-width: 900px) {
  }
  @media (min-width: 900px) {
    margin-left: 30px;
    row-gap: 16px;
  }
`;

export const PayoffAmountHeaderMobile = styled.div.attrs({
  id: 'payoffAmountHeader',
  'aria-label': 'Payoff Amount Header',
})`
  font-size: 16px;
  font-weight: 700;

  @media (min-width: 900px) {
    /* display: none; */
  }
`;
export const PayoffAmountData = styled.div.attrs({
  id: 'payoffAmountData',
  'aria-label': 'Payoff Amount Data',
})``;
export const CurrentDueHeaderMobile = styled.div.attrs({
  id: 'currentDueHeader',
  'aria-label': 'Current Due Header',
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    /* display: none; */
  }
`;
export const CurrentDueData = styled.div.attrs({
  id: 'currentDueData',
  'aria-label': 'Current Due Data',
})`
  grid-area: data;
`;
export const DueDateHeaderMobile = styled.div.attrs({
  id: 'accountDueDateHeader',
  'aria-label': 'Account Due Date Header',
})`
  font-size: 16px;
  font-weight: 700;
  @media (max-width: 900px) {
    display: none;
  }
`;
export const DueDateData = styled.div.attrs({
  id: 'accountDueDateData',
  'aria-label': 'Due Date Data',
})`
  grid-area: data;
`;

export const RecentPaymentsHeader = styled.h3.attrs({
  id: 'recentPaymentsHeader',
  'aria-label': 'Recent Payments Header',
})`
  font-family: 'Helvetica Neue', Lato, proxima-nova, Arial, Helvetica, sans-serif, sans-serif;
  font-size: 18px;
  margin-left: 30px;
`;
export const PendingPaymentsHeader = styled.h3.attrs({
  id: 'pendingPaymentsHeader',
  'aria-label': 'Pending Payments Header',
})`
  font-family: 'Helvetica Neue', Lato, proxima-nova, Arial, Helvetica, sans-serif, sans-serif;
  font-size: 18px;
  margin-left: 30px;
`;

export const RecentPaymentDataContainer = styled.div.attrs({
  id: 'recentPaymentsDataContainer',
  'aria-label': 'Recent Payments Data',
})`
  display: flex;
  margin-left: 60px;
  margin-top: 2%;
  @media (max-width: 599px) {
    margin-bottom: 5%;
    border-bottom: 2px solid ${(props) => props.theme.gray};
    padding-bottom: 5%;
    flex-direction: column;
    gap: 15px;
  }
  @media (min-width: 600px) and (max-width: 899px) {
    margin-bottom: 5%;
    border-bottom: 2px solid ${(props) => props.theme.gray};
    padding-bottom: 5%;
    flex-direction: column;
    gap: 15px;
  }
  @media (min-width: 900px) and (max-width: 939px) {
    margin-left: 30px;
  }

  @media (min-width: 940px) {
    margin-right: 30px;
  }
`;
export const PendingScheduledPaymentsContainer = styled.div.attrs((props) => ({
  id: `pendingScheduledPaymentsContainer${props.$info ? props.$info : ''}`,
  'aria-label': `Pending and Scheduled Payments ${props.$info ? props.$info : ''}`,
}))`
  display: flex;
  margin-left: 60px;
  @media (max-width: 599px) {
    margin-bottom: 5%;
    border-bottom: 2px solid ${(props) => props.theme.gray};
    padding-bottom: 5%;
    flex-direction: column;
    gap: 15px;
    display: ${(props) => (props.$tableHeader ? 'none' : 'flex')};
  }
  @media (min-width: 600px) and (max-width: 899px) {
    margin-bottom: 5%;
    border-bottom: 2px solid ${(props) => props.theme.gray};
    padding-bottom: 5%;
    flex-direction: column;
    gap: 15px;
    margin-top: 4%;
    display: ${(props) => (props.$tableHeader ? 'none' : 'flex')};
  }
  @media (min-width: 900px) and (max-width: 1000px) {
    margin-left: 30px;
  }
  @media (min-width: 1000px) {
    margin-right: 30px;
    margin-top: 2%;
  }
`;
export const PaymentIdContainer = styled.div.attrs({
  id: 'paymentIdContainer',
  'aria-label': 'Payment Id Container',
})`
  flex: 1;
  @media (max-width: 900px) {
  }
  @media (min-width: 900px) {
  }
`;
export const PaymentIdHeaderMobile = styled.div.attrs({
  id: 'paymentIdHeader',
  'aria-label': `Payment Id Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const PaymentIdData = styled.div.attrs({
  id: 'paymentIdData',
  'aria-label': `Payment Receipt Id Data`,
})``;
export const ReceiptDateContainer = styled.div.attrs({
  id: 'receiptDateContainer',
  'aria-label': `Receipt Date Container`,
})`
  flex: 1;
`;
export const DescriptionContainer = styled.div.attrs({
  id: 'descriptionContainer',
  'aria-label': `Description Container`,
})`
  flex: 1;
`;

export const TypeContainer = styled.div.attrs({
  id: 'typeContainer',
  'aria-label': `Payment Type Container`,
})`
  flex: 1;
`;
export const ReceiptDateHeaderMobile = styled.div.attrs({
  id: 'receiptDateHeader',
  'aria-label': `Receipt Date Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const ReceiptDescriptionHeaderMobile = styled.div.attrs({
  id: 'receiptDescriptionHeader',
  'aria-label': `Receipt Description Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const ReceiptTypeHeaderMobile = styled.div.attrs({
  id: 'receiptTypeHeader',
  'aria-label': `Receipt Type Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const ReceiptDateData = styled.div.attrs({
  id: 'receiptDateData',
  'aria-label': `Receipt Date Data`,
})``;
export const ReceiptDescriptionData = styled.div.attrs({
  id: 'receiptDescriptionData',
  'aria-label': `Receipt Description Data`,
})``;
export const ReceiptTypeData = styled.div.attrs({
  id: 'receiptTypeData',
  'aria-label': `Receipt Type Data`,
})``;
export const AmountContainer = styled.div.attrs({
  id: 'amountContainer',
  'aria-label': `Amount Container`,
})`
  flex: 1;
`;
export const AmountHeaderMobile = styled.div.attrs({
  id: 'amountHeader',
  'aria-label': `Amount Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;

  @media (min-width: 900px) {
    display: none;
  }
`;
export const AmountData = styled.div.attrs({
  id: 'amountData',
  'aria-label': `Amount Data`,
})``;
export const StatusContainer = styled.div.attrs({
  id: 'statusContainer',
  'aria-label': `Status Container`,
})`
  flex: 1;
`;
export const CancelContainer = styled.div.attrs({
  id: 'cancelContainer',
  'aria-label': `Cancel Container`,
})`
  flex: 1;
`;
export const StatusHeaderMobile = styled.div.attrs({
  id: 'statusHeader',
  'aria-label': `Status Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const CancelHeaderMobile = styled.div.attrs({
  id: 'cancelHeader',
  'aria-label': `Cancel Mobile Header`,
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;

export const StatusData = styled.div.attrs({
  id: 'statusData',
  'aria-label': `Status Data`,
})``;

export const RecentPaymentHeaderContainer = styled.div.attrs({
  id: 'recentPaymentHeaderContainer',
  'aria-label': `Recent Payment Header Container`,
})`
  display: flex;
  margin-left: 60px;
  margin-bottom: 20px;
  @media (max-width: 899px) {
    display: none;
  }
  @media (min-width: 900px) and (max-width: 939px) {
    margin-left: 30px;
  }
  @media (min-width: 940px) {
    margin-right: 30px;
  }
`;

export const PaymentIdHeader = styled.div.attrs({
  id: 'paymentIdHeader',
  'aria-label': 'Payment Id Header',
})`
  font-weight: 700;
  text-align: left;
  flex: 1;
  word-break: break-word;
  @media (max-width: 899px) {
    display: none;
  }
`;
export const ReceiptDateHeader = styled.div.attrs({
  id: 'receiptDateHeader',
  'aria-label': 'Receipt Date Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 899px) {
    display: none;
  }
`;
export const ReceiptDescriptionHeader = styled.div.attrs({
  id: 'receiptDescriptionHeader',
  'aria-label': 'Receipt Description Header',
})`
  font-weight: 700;
  text-align: left;
  word-break: break-word;
  flex: 1;
  @media (max-width: 899px) {
    display: none;
  }
`;

export const ReceiptTypeHeader = styled.div.attrs({
  id: 'receiptTypeHeader',
  'aria-label': 'Payment Receipt Type Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 899px) {
    display: none;
  }
`;
export const AmountHeader = styled.div.attrs({
  id: 'amountHeader',
  'aria-label': 'Payment Amount Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 899px) {
    display: none;
  }
`;
export const StatusHeader = styled.div.attrs({
  id: 'statusHeader',
  'aria-label': 'Payment Status Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 899px) {
    display: none;
  }
`;
export const CancelHeader = styled.div.attrs({
  id: 'cancelHeader',
  'aria-label': 'Cancel Scheduled Payment Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 899px) {
    display: none;
  }
`;
export const CancelButton = styled.button.attrs({
  id: 'cancelButton',
  'aria-label': 'Cancel Scheduled Payment Button',
})`
  padding: 8px 12px;
  border: 0;
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  position: relative;
  @media (max-width: 899px) {
    position: initial;
  }
  @media (min-width: 1000px) {
    bottom: 8px;
  }
  &:disabled {
    background-color: gray;
  }
`;

export const BalancesHeader = styled.h3.attrs({
  id: 'balancesHeader',
})`
  margin: 30px;
`;

export const UnderlyingPoliciesWarning = styled.h3.attrs({
  id: 'underlyingpoliciesHeader',
  'aria-label': 'No Underlying Policies Header',
})`
  margin: 30px;
  max-width: 600px;
`;

export const BalancesDataContainer = styled.div.attrs({
  id: 'balancesDataContainer',
  'aria-label': 'Billing Balances and Pay Schedule Container',
})`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  margin-left: 30px;
  @media (max-width: 899px) {
    margin-bottom: 140px;
    margin-left: 60px;
    flex-direction: column;
    gap: 20px;
  }
  @media (min-width: 1000px) {
    margin-left: 60px;
    margin-right: 30px;
  }
`;
export const PolicyNumberContainer = styled.div.attrs({
  id: 'policyNumberContainer',
  'aria-label': 'Policy Number Container',
})`
  flex: 1;
  @media (min-width: 900px) {
  }
`;
export const PolicyNumberHeaderMobile = styled.div.attrs({})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const PolicyNumberData = styled.div.attrs({})``;
export const PayoffAmountBalancesContainer = styled.div.attrs({
  id: 'payoffAmountBalancesContainer',
  'aria-label': 'Payoff Amount Balances Container',
})`
  flex: 1;
  @media (min-width: 900px) {
  }
`;
export const PayoffAmountBalancesHeaderMobile = styled.div.attrs({})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const PayoffAmountBalancesData = styled.div.attrs({})``;
export const CurrentDueBalancesContainer = styled.div.attrs({
  id: 'currentDueBalancesContainer',
  'aria-label': 'Current Due Balances Container',
})`
  flex: 1;

  @media (min-width: 900px) {
  }
`;
export const CurrentDueBalancesHeaderMobile = styled.div.attrs({
  id: 'currentDueBalancesMobileHeader',
  'aria-label': 'Current Due Balances Mobile Header',
})`
  font-size: 16px;
  font-weight: 700;

  @media (min-width: 900px) {
    display: none;
  }
`;
export const CurrentDueBalancesData = styled.div.attrs({})``;
export const DueDateBalancesContainer = styled.div.attrs({
  id: 'dueDateBalancesContainer',
  'aria-label': 'Due Date Balances Container',
})`
  flex: 1;
  @media (max-width: 900px) {
  }
  @media (min-width: 900px) {
    position: relative;
    bottom: 6px;
  }
`;
export const DueDateBalancesHeaderMobile = styled.div.attrs({
  id: 'dueDateMobileHeader',
  'aria-label': 'Due Date Balances Mobile Header',
})`
  font-size: 16px;
  font-weight: 700;
  @media (min-width: 900px) {
    display: none;
  }
`;

export const BalancesHeaderContainer = styled.div.attrs({
  id: 'balancesTableHeader',
  'aria-label': 'Balances Table Header',
})`
  display: flex;
  margin-left: 30px;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    display: none;
  }
  @media (min-width: 1000px) {
    margin-left: 60px;
    margin-right: 30px;
  }
`;

export const PolicyNumberBalancesHeader = styled.div.attrs({
  id: 'policyNumberBalancesHeader',
  'aria-label': 'Policy Number Balances Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 900px) {
    display: none;
  }
`;
export const PayoffAmountBalancesHeader = styled.div.attrs({
  id: 'payoffAmountBalancesHeader',
  'aria-label': 'Payoff Amount Balances Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 900px) {
    display: none;
  }
`;
export const CurrentDueBalancesHeader = styled.div.attrs({
  id: 'currentDueBalancesHeader',
  'aria-label': 'Current Due Balances Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 900px) {
    display: none;
  }
`;
export const DueDateBalancesHeader = styled.div.attrs({
  id: 'dueDateBalancesHeader',
  'aria-label': 'Due Date Balance Header',
})`
  font-weight: 700;
  flex: 1;
  @media (max-width: 900px) {
    display: none;
  }
`;
export const PaymentScheduleButton = styled.div.attrs((props) => ({
  id: `showHidePaymentPlan${props.$accountNumber}`,
  'aria-label': `Show Hide Payment Plan Button for ${props.$accountNumber}`,
}))`
  display: inline-block;
  width: 65%;
  margin-bottom: 2%;
  position: relative;
  bottom: 6px;
  @media (max-width: 600px) {
    width: 86%;
  }
  @media (max-width: 900px) {
    margin-top: 4%;
  }
`;
export const PaymentScheduleHideButton = styled.button.attrs({
  id: 'hidePaymentScheduleButton',
  'aria-label': 'Hide Payment Schedule Button',
})`
  display: inline-block;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;
  position: relative;
  width: 48%;
  bottom: 8px;

  &:hover {
    background-color: transparent;
  }

  &:active {
    background-color: transparent;
  }

  @media (max-width: 600px) {
    width: 86%;
  }
  @media (max-width: 900px) {
    margin-top: 4%;
    width: initial;
  }
`;
export const PaymentScheduleCancelButton = styled.button.attrs({
  id: 'cancelButton',
})`
  display: inline-block;
  color: #00739d;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: transparent;
  }

  &:active {
    background-color: transparent;
  }
`;

export const PayPlanScheduleContainer = styled.div.attrs({
  id: 'currentPayPlanSchedule',
})`
  background-color: #dfdedf;
  padding: 20px;
  flex: 1;
  flex-basis: 100%;
  margin: 30px;
  @media (max-width: 599px) {
    grid-column: initial;
    margin: initial;
    margin-top: 15px;
    overflow: auto;
  }
`;

export const NoRecentPayments = styled.div.attrs({
  id: 'noRecentPaymentsErrorMessage',
})`
  margin-left: 60px;
  font-size: 16px;
  margin-top: 20px;
`;
export const HidePaymentArea = styled.div.attrs({
  id: 'paymentScheduleContainer',
})`
  cursor: pointer;
  @media (max-width: 600px) {
    position: relative;
    right: 7px;
  }
  @media (min-width: 900px) {
    position: initial;
  }
`;
export const NewPaymentActionContainer = styled.div`
  cursor: pointer;
`;
export const ShowPaymentContainer = styled.div.attrs({
  id: 'showPaymentScheduleContainer',
})`
  cursor: pointer;
  @media (max-width: 600px) {
    position: relative;
    right: 7px;
  }
`;
export const PaymentScheduleEditButton = styled.button.attrs((props) => ({
  id: props.id ? props.id : 'editPaySchedule',
}))`
  color: #00a5b8;
  background-color: transparent;
  box-shadow: none;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #008a9a;
    background-color: transparent;
  }

  &:active {
    color: #006f7c;
    background-color: transparent;
  }
`;
export const ChangePayScheduleEditScreenContainer = styled.div.attrs({
  id: 'changePayScheduleEditScreenContainer',
})`
  background-color: white;
  padding: 20px;
  margin-top: 20px;
`;
export const PayScheduleEditHeader = styled.h1.attrs({
  id: 'payScheduleEditHeader',
})`
  margin: 0;
`;
export const EditPaymentScheduleButtonContainer = styled.div.attrs({
  id: 'editPayScheduleButtonContainer',
})`
  float: right;
  margin-top: 16px;
`;
export const PayPlanButtonContainer = styled.div.attrs({
  id: 'payPlanOptionsContainers',
})`
  width: 24%;
  margin: 20px 0;
  @media (max-width: 600px) {
    width: 80%;
  }
`;
export const DateOfPaymentContainer = styled.div.attrs({
  id: 'dateOfMonthToPayContainer',
})`
  width: 40%;
  margin: 20px 0;
  @media (max-width: 600px) {
    width: 80%;
  }
`;
export const SelectPayPlanHeader = styled.div`
  margin: 20px 0;
`;
export const PaymentDateHeader = styled.div`
  margin: 20px 0;
`;
export const StyledPayDateInput = styled(InputMask).attrs({
  type: 'number',
})``;
export const SelectPayMethodHeader = styled.div.attrs({
  id: 'paymentMethodHeader',
  'aria-label': 'Pay Method Header',
})`
  margin: 20px 0;
`;
export const SaveNewPaymentScheduleButton = styled.button.attrs({
  id: 'SaveNewPaymentScheduleButton',
})`
  color: white;
  padding: 8px 20px;
  margin-left: 8px;
`;
export const CurrentPayPlanHeader = styled.h2.attrs({
  id: 'currentPayPlan',
})`
  margin: 0 0 20px 0;
`;
export const RequiredField = styled.span.attrs({})`
  color: red;
`;
export const BillNumber = styled.span.attrs({
  id: 'billNumber',
})`
  position: relative;
  bottom: 7px;
`;
export const BillNumberHeader = styled.span.attrs({
  id: 'billNumberHeader',
})`
  margin-left: 24px;
`;
export const ShowPaymentsButton = styled.button.attrs({
  id: 'showPaymentButtons',
})`
  flex: 0.9;
  color: ${(props) => props.theme.primaryColor};
  background-color: initial;
  box-shadow: initial;
  @media (max-width: 600px) {
    display: block;
    margin: 0 auto;
  }

  &:hover {
    color: ${(props) => props.theme.primaryHoverColor};
    background-color: initial;
    box-shadow: initial;
    text-decoration: underline;
  }

  &:active {
    color: ${(props) => props.theme.primaryHoverColor};
    background-color: initial;
    box-shadow: initial;
  }
`;
export const ShowRecentPaymentsButton = styled.button.attrs({
  id: 'showRecentPaymentButtons',
})`
  grid-column-start: 3;
  color: ${(props) => props.theme.primaryColor};
  background-color: initial;
  box-shadow: initial;
  @media (max-width: 600px) {
    display: block;
    margin: 0 auto;
  }

  &:hover {
    color: ${(props) => props.theme.primaryHoverColor};
    background-color: initial;
    box-shadow: initial;
    text-decoration: underline;
  }

  &:active {
    color: ${(props) => props.theme.primaryHoverColor};
    background-color: initial;
    box-shadow: initial;
  }
`;
export const TableFix = styled.div.attrs({
  id: 'tableFix',
})`
  display: flex;
  justify-content: center;
  margin-top: 12px;
  @media (max-width: 600px) {
    display: block;
    margin: 0 auto;
  }
`;
export const ShowHidePendingPaymentsContainer = styled.div.attrs({
  id: 'ShowHidePendingPaymentsContainer',
  'aria-label': 'Show Hide Pending Payments Container',
})`
  display: flex;
  margin-top: 12px;
  @media (max-width: 600px) {
    display: block;
    margin: 0 auto;
  }
  @media (min-width: 940px) {
    margin-right: 30px;
    margin-left: 60px;
  }
`;

export const StyledModal = styled.div`
  padding: 16px 24px;
  @media (max-width: 599px) {
    width: calc(100% - 64px);
  }
  @media (min-width: 600px) and (max-width: 979px) {
    width: 361px;
  }
  @media (min-width: 900px) and (max-width: 1279px) {
    width: 361px;
  }
  @media (min-width: 1280px) {
    width: 361px;
  }
  min-height: 260px;
`;

export const RadioChoice = styled.input.attrs({
  type: 'radio',
})`
  margin-left: 16px;
  margin-top: 16px;
  height: 24px;
  width: 24px;
`;
export const PaymentCards = styled.div`
  margin-bottom: 24px;
  height: 56px;
  display: block;
  width: 350px;
  border-radius: 4px;
  background-color: #fafafa;

  &:hover {
    background-color: #fafafa;
  }
  @media (max-width: 599px) {
    width: 100%;
  }
  @media (min-width: 600px) and (max-width: 979px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const CreditCard = styled(PaymentCards)`
  font-size: 16px;
`;
export const ACHCard = styled(PaymentCards)`
  font-size: 16px;
`;
export const AddNewCard = styled.button.attrs({
  id: 'addNewCardButton',
})`
  border: 2px solid ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.primaryColor};
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  height: 40px;
  display: block;
  margin-top: 0;
  margin-bottom: 16px;

  &:hover {
    color: ${(props) => props.theme.primaryColor};
    background-color: white;
  }
  box-shadow: 0 1px 4px 0 rgba(40, 51, 63, 0.24);
  @media (max-width: 599px) {
    width: 100%;
  }
  @media (min-width: 600px) and (max-width: 979px) {
    width: 290px;
  }
  @media (min-width: 900px) and (max-width: 1279px) {
    width: 290px;
  }
  @media (min-width: 1280px) {
    width: 290px;
  }
`;
export const AddNewPaymentType = styled.button.attrs({
  id: 'addNewPaymentTypeButton',
})`
  border: 2px solid ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.primaryColor};
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  height: 40px;
  display: block;

  &:hover {
    color: ${(props) => props.theme.primaryColor};
    background-color: white;
  }
  box-shadow: 0 1px 4px 0 rgba(40, 51, 63, 0.24);
  @media (max-width: 599px) {
    width: 100%;
  }
  @media (min-width: 600px) and (max-width: 979px) {
    width: 290px;
  }
  @media (min-width: 900px) and (max-width: 1279px) {
    width: 290px;
  }
  @media (min-width: 1280px) {
    width: 290px;
  }
`;
export const AddNewBankAccount = styled.button.attrs({
  id: 'addNewBankAccountButton',
})`
  border: 2px solid ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.primaryColor};
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  height: 40px;
  display: block;

  &:hover {
    color: ${(props) => props.theme.primaryColor};
    background-color: white;
  }
  box-shadow: 0 1px 4px 0 rgba(40, 51, 63, 0.24);
  @media (max-width: 599px) {
    width: 100%;
  }
  @media (min-width: 600px) and (max-width: 979px) {
    width: 290px;
  }
  @media (min-width: 900px) and (max-width: 1279px) {
    width: 290px;
  }
  @media (min-width: 1280px) {
    width: 290px;
  }
`;

export const StyledCreditIcon = styled(CreditCardIcon).attrs({
  className: 'fa fa-lg fa-credit-card',
})`
  margin-left: 8px;
`;
export const StyledModalCreditIcon = styled(CreditCardIcon).attrs({
  className: 'fa fa-lg fa-credit-card',
})`
  position: relative;
  top: 3px;
`;
export const StyledDeleteIcon = styled(DeleteIcon).attrs({
  className: 'fa fa-lg fa-trash',
})`
  cursor: pointer;
  top: 17px;
  right: 22px;
  position: relative;
  float: right;
`;
export const CreditInfo = styled.span.attrs({
  id: 'creditCardInfo',
  className: 'creditInfoSpan',
})`
  margin-left: 8px;
  bottom: 6px;
  font-weight: 400;
  position: relative;
`;

export const StyledACHIcon = styled(AccountBalanceIcon).attrs({
  className: 'fa fa-lg fa-university',
})`
  margin-left: 8px;
`;
export const StyledModalACHIcon = styled(AccountBalanceIcon).attrs({
  className: 'fa fa-lg fa-university',
})`
  margin-left: 18px;
  position: relative;
  top: 3px;
`;

export const ACHInfo = styled.span.attrs({
  className: 'creditInfoSpan',
})`
  margin-left: 8px;
  bottom: 5px;
  font-weight: 400;
  position: relative;
`;
export const StyledAddIcon = styled(AddIcon).attrs({
  className: 'fa fa-lg fa-plus',
})`
  position: relative;
  top: 2px;
  color: ${(props) => props.theme.primaryColor};
  @media (max-width: 599px) {
    margin-left: 3px;
  }
`;
export const AddPaymentInfo = styled.span.attrs({
  className: 'addPaymentInfoSpan',
})`
  font-size: 16px;
  bottom: 4px;
  position: relative;
  margin-left: 8px;
  font-weight: 400;
  color: ${(props) => props.theme.primaryColor};
  /* text-decoration: none; */
`;
export const StyledDeleteButton = styled.button.attrs({
  id: 'deleteCardYesButton',
})`
  background-color: #b82323;

  &:hover {
    background-color: red;
  }

  &:active {
    background-color: #ad1c1c;
  }
  color: white;
  border: none;
  padding: 6px 55px 6px 55px;
  margin-right: 14px;
`;
export const StyledButtonNextDeleteCard = styled.button.attrs({
  id: 'deleteCardNoButton',
})`
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  border: none;
  padding: 6px 55px 6px 55px;
`;
export const StyledTextSpan = styled.span.attrs({})`
  margin-left: 16px;
  font-size: 18px;
  position: relative;
  bottom: 3px;
  font-family: proxima-nova, Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  text-decoration: none;
`;
export const StyledHorizontalLine = styled.div`
  background-color: #7d91ac;
  height: 1px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 979px) {
    margin-right: 24px;
    margin-left: 24px;
  }
  @media (min-width: 900px) and (max-width: 1279px) {
    margin-right: 24px;
    margin-left: 24px;
  }
  @media (min-width: 1280px) {
    margin-right: 24px;
    margin-left: 24px;
  }
`;
export const StyledDialogSpan = styled.span`
  padding: 16px 24px;
  color: gray;
  font-size: 18px;
`;
export const StyledDialogActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  padding: 16px 24px;
  align-items: center;
  justify-content: flex-start;
`;
export const AutomatedPayPlanOptInContainer = styled.div.attrs({
  id: 'AutomatedPayPlanOptInContainer',
})``;
export const AutomatedPayPlanOptInBottomContainer = styled.div.attrs({
  id: 'AutomatedPayPlanOptInBottomContainer',
})`
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
`;
export const CancelLoadingContainer = styled.div.attrs({
  id: 'CancelLoadingContainer',
  'aria-label': 'CancelLoadingContainer',
})`
  display: inline-block;
`;
